import React from 'react'

export default function AngularIcon() {
   return (
      <svg
         width="64"
         height="64"
         viewBox="0 0 64 64"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M31.9049 0.512939L2.27637 10.9399L6.95787 49.7584L31.9364 63.4869L57.0434 49.5729L61.7234 10.7554L31.9049 0.512939Z"
            fill="#1F473E"
         />
         <path
            d="M58.7679 12.999L31.8359 3.81445V60.207L54.4064 47.7155L58.7679 12.999Z"
            fill="#1F473E"
         />
         <path
            d="M5.60059 13.1645L9.61359 47.8815L31.8356 60.207V3.81348L5.60059 13.1645Z"
            fill="#1F473E"
         />
         <path
            d="M39.2491 33.8351L31.8356 37.3021H24.0216L20.3481 46.4891L13.5166 46.6161L31.8356 5.86206L39.2491 33.8351ZM38.5321 32.0896L31.8846 18.9291L26.4316 31.8631H31.8351L38.5321 32.0896Z"
            fill="#F1ECDC"
         />
         <path
            d="M31.8359 5.86206L31.8849 18.9291L38.0724 31.8731H31.8494L31.8359 37.2936L40.4404 37.3021L44.4614 46.6171L50.9984 46.7381L31.8359 5.86206Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
